import setTitle from './setTitle'
import permission from './permission'

function addMiddleWares({ router, store }) {
  router.beforeEach(setTitle({ router, store }))
  // router.beforeEach(permission({ router, store }))
}

export default addMiddleWares
